var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenEdete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3078 4.14819C15.8388 2.61727 18.3209 2.61727 19.8518 4.14819C21.3827 5.67911 21.3827 8.16121 19.8518 9.69213L11.9107 17.6333C11.457 18.087 11.1898 18.3542 10.8927 18.5859C10.5426 18.859 10.1636 19.0932 9.76268 19.2843C9.42253 19.4464 9.06418 19.5658 8.45544 19.7687L5.6666 20.6983L4.99509 20.9222C4.45044 21.1037 3.84995 20.962 3.44399 20.556C3.03803 20.15 2.89627 19.5495 3.07783 19.0049L4.23127 15.5446C4.43416 14.9358 4.55359 14.5775 4.71571 14.2373C4.90678 13.8364 5.14097 13.4575 5.41412 13.1073C5.64587 12.8102 5.91297 12.5431 6.36672 12.0893L14.3078 4.14819ZM5.63763 19.3843L8.01658 18.5912C8.6789 18.3705 8.96031 18.2755 9.22241 18.1506C9.541 17.9988 9.8421 17.8127 10.1204 17.5956C10.3493 17.4171 10.5601 17.2078 11.0538 16.7141L17.391 10.377C16.7307 10.1441 15.8801 9.71243 15.0838 8.91614C14.2876 8.11985 13.8559 7.26925 13.6231 6.60899L7.28581 12.9462C6.79214 13.4399 6.58291 13.6506 6.40434 13.8796C6.18728 14.1579 6.00119 14.459 5.84936 14.7776C5.72445 15.0396 5.6295 15.3211 5.40872 15.9834L4.61574 18.3624L5.63763 19.3843ZM14.6417 5.59036C14.6703 5.73683 14.7187 5.93596 14.7994 6.16872C14.9813 6.69278 15.3247 7.38101 15.9719 8.02815C16.619 8.67528 17.3072 9.01872 17.8312 9.20053C18.0641 9.28129 18.2631 9.32968 18.4097 9.35831L18.9638 8.80413C20.0043 7.76364 20.0043 6.07667 18.9638 5.03618C17.9233 3.99569 16.2363 3.99569 15.1959 5.03618L14.6417 5.59036Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdete);
export default __webpack_public_path__ + "static/media/pen_edete.dd7e5948fbeba490a4845b78c83cd85f.svg";
export { ForwardRef as ReactComponent };